export class ChangeShowDialpad {
   public static readonly type = '[CallControlSettings] Change show dialpad';

   constructor(public brickInstanceId, public showDialpad: boolean) {}
}
